.page {
  display: grid;
  min-height: 100vh;
  min-height: 100dvh;
  grid-template-columns: minmax(0, 1.08fr) minmax(28rem, 0.92fr);
  background: var(--color-background-2);
}

.showcase {
  position: sticky;
  top: 0;
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  flex-direction: column;
  padding: 2.25rem clamp(2rem, 5vw, 4.5rem) 3rem;
  background: #0e1319;
  color: #f3f4f6;
}

.backdrop {
  position: absolute !important;
  inset: 0;
}

.brand,
.visualization,
.story {
  position: relative;
  z-index: 1;
}

.brand {
  align-self: flex-start;
  color: #fff;
  transition: opacity 150ms ease;

  &:hover {
    opacity: 0.82;
  }
}

.visualization {
  flex: 1;
  min-height: 12rem;
  margin: 1.5rem 0;
}

.story {
  width: min(100%, 40rem);
}

.storyTitle {
  max-width: 36rem;
  color: #fff;
  font-size: clamp(2.5rem, 4.2vw, 4rem);
  text-wrap: balance;
}


.proofList {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  margin-top: 1.5rem;
  padding: 0;
  list-style: none;

  > li {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #d5dbe3;
    font-size: 0.875rem;
  }

  svg {
    width: 1rem;
    height: 1rem;
    color: #8f8cff;
  }
}

.authColumn {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 100vh;
  min-height: 100dvh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem clamp(2rem, 6vw, 5rem);
  padding-top: max(2rem, env(safe-area-inset-top));
  padding-right: max(clamp(2rem, 6vw, 5rem), env(safe-area-inset-right));
  padding-bottom: max(2rem, env(safe-area-inset-bottom));
  padding-left: max(clamp(2rem, 6vw, 5rem), env(safe-area-inset-left));
  background: var(--color-background);
}

.authCard {
  display: flex;
  width: min(100%, 24rem);
  flex: 1;
  flex-direction: column;
  justify-content: center;
}

.mobileBrand {
  display: none;
}

.authContent {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.authHeader {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.legal {
  width: min(100%, 24rem);
  text-wrap: balance;
}

.additionalContent {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--color-border);
  text-align: center;
}

@media (max-width: 1023px) {
  .page {
    display: block;
  }

  .showcase {
    display: none;
  }

  .mobileBrand {
    display: block;
    align-self: flex-start;
  }
}

@media (max-width: 480px) {
  .authColumn {
    padding-right: max(1rem, env(safe-area-inset-right));
    padding-left: max(1rem, env(safe-area-inset-left));
  }
}

